import { render } from "./ContactTable.vue?vue&type=template&id=d6228620&ts=true"
import script from "./ContactTable.vue?vue&type=script&lang=ts"
export * from "./ContactTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__